import React, { Component } from 'react';

export default class ZNumpad extends Component {

    constructor(props) {
        super(props);

        this.state = {
            displayString: "0",
            isFirstHit: true
        }

        this.handleKeyPress = this.handleKeyPress.bind(this);

        this.updateDisplayString = this.updateDisplayString.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.isActive != this.props.isActive) {

            if (this.props.isActive) {
                let displayString = "0";
                if (this.props.defaultValue != undefined) {
                    displayString = this.props.defaultValue + "";
                }

                document.addEventListener('keydown', this.handleKeyPress);

                this.setState({ displayString: displayString, isFirstHit: true });
            } else {

                document.removeEventListener('keydown', this.handleKeyPress);
            }
        }
    }

    handleKeyPress(event) {

        let key = event.key;
        let allowedKeys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '.', 'Backspace', 'Enter', 'c', 'C'];

        if (allowedKeys.includes(key)) {
            if (key === 'Backspace') {
                key = 'back';
            } else if (key === 'c' | key === 'C') {
                key = 'C';
            }

            if (key != 'Enter') {
                this.updateDisplayString(key);
            } else {
                this.props.handleConfirm(this.state.displayString);
            }
        }
    }

    updateDisplayString(num) {

        let displayString = this.state.displayString;

        if (num === 'C') {
            displayString = "0";
        } else if (num === 'back') {
            if (displayString.length === 1) {
                displayString = "0";
            } else {
                displayString = displayString.substring(0, displayString.length - 1);
            }
        } else if (num === 'D') {
            if (this.props.defaultValue != undefined) {
                displayString = this.props.defaultValue + '';
            } else {
                displayString = "0";
            }
        } else if (displayString.length < 9 &&
            (num != "." || (num === "." && displayString.length < 8 && !displayString.includes('.')))) {

            displayString = ((this.state.isFirstHit ? '' : displayString) + num).replace(/^0+/, '');
            if (displayString.length === 0) {
                displayString = "0";
            }
        }

        let grabId = "num" + (num === '.' ? 'dot' : num);
        document.getElementById(grabId).classList.add('blink');

        setTimeout(() => {
            document.getElementById(grabId).classList.remove('blink');
        }, 16);

        this.setState({ displayString: displayString, isFirstHit: false });
    }

    render() {


        return (
            <div className={"settings-numpad-container" + (this.props.isActive ? " active" : "")}>
                <div className={"shadow"} onClick={this.props.handleCancel}></div>
                <div className={"numpad-outer"}>
                    <div className={"numpad-display"}>{this.state.displayString}</div>
                    <div className={"numpad-underline"}></div>
                    <div className={"numpad-numbers-container"}>
                        <div id={"num7"} className={"numpad-button t l"} onClick={this.updateDisplayString.bind(null, "7")}>7</div>
                        <div id={"num8"} className={"numpad-button t lm"} onClick={this.updateDisplayString.bind(null, "8")}>8</div>
                        <div id={"num9"} className={"numpad-button t rm"} onClick={this.updateDisplayString.bind(null, "9")}>9</div>
                        <div id={"num4"} className={"numpad-button tm l"} onClick={this.updateDisplayString.bind(null, "4")}>4</div>
                        <div id={"num5"} className={"numpad-button tm lm"} onClick={this.updateDisplayString.bind(null, "5")}>5</div>
                        <div id={"num6"} className={"numpad-button tm rm"} onClick={this.updateDisplayString.bind(null, "6")}>6</div>
                        <div id={"num1"} className={"numpad-button bm l"} onClick={this.updateDisplayString.bind(null, "1")}>1</div>
                        <div id={"num2"} className={"numpad-button bm lm"} onClick={this.updateDisplayString.bind(null, "2")}>2</div>
                        <div id={"num3"} className={"numpad-button bm rm"} onClick={this.updateDisplayString.bind(null, "3")}>3</div>
                        <div id={"num0"} className={"numpad-button b l wide"} onClick={this.updateDisplayString.bind(null, "0")}>0</div>
                        <div id={"numdot"} className={"numpad-button b rm"} onClick={this.updateDisplayString.bind(null, ".")}>.</div>

                        <div id={"numD"} className={"numpad-button t r"} onClick={this.updateDisplayString.bind(null, "D")}>D</div>
                        <div id={"numC"} className={"numpad-button tm r"} onClick={this.updateDisplayString.bind(null, "C")}>C</div>
                        <div id={"numback"} className={"material-icons numpad-button bm r tall"} onClick={this.updateDisplayString.bind(null, "back")}>backspace</div>
                    </div>
                    <div className={"numpad-confirm-button-container"}>
                        <div className={"numpad-confirm-button numpad-cancel"} onClick={this.props.handleCancel}>{"Cancel"}</div>
                        <div className={"numpad-confirm-button numpad-confirm"} onClick={this.props.handleConfirm.bind(null, this.state.displayString)}>{"Confirm"}</div>
                    </div>
                </div>
            </div>
        );
    }
}